import React, { useState, useRef, useEffect } from 'react'
import moment from 'moment'
import { Popconfirm, Popover, Checkbox } from 'antd'
import CategoryEdit from './CategoryEdit'

const CategoryRow = ({ category, skus = [], reload, onleDelete, key, listSelected = [], handleSelectItem }) => {
    const { name = '', products = [], created_at = '', updated_at = '', _id } = category
    const listSkus = products.map(i => i.sku) || []
    const refSKU = useRef(null)
    const [showAllSku, setShowAllSku] = useState(false)
    const [isLongSku, setIsLongSku] = useState(false)

    const showallonclick = () => {
        setShowAllSku(!showAllSku)
    }

    useEffect(() => {
        if (refSKU.current && refSKU.current.offsetHeight > 85) {
            setIsLongSku(true)
        } else {
            setIsLongSku(false)
        }
    }, [listSkus])

    const formatName = (name = '') => {
        if (name.length > 30) {
            return <Popover content={name} title="Danh mục sản phẩm" trigger="click" placement="topLeft">
                <span className='cursor-pointer'>{name.slice(0, 30) + '...'}</span>
            </Popover>
        }
        return name
    }

    const getSku = (skus = []) => {
        return skus.length > 0 &&
            <>
                <div className={showAllSku ? '' : 'LessItems'}>
                    <div ref={refSKU}>
                        <label className='mb-0'>{skus.join(', ')}</label>
                    </div>
                </div>
                {
                    isLongSku && (
                        <a className="float-right mr-3 text-primary" onClick={showallonclick}>
                            <small className="float-right">{showAllSku ? 'Less...' : 'More...'}</small>
                        </a>
                    )
                }
            </>
    }

    return (
        <tr key={key}>
            <td><Checkbox checked={listSelected.some(i => i._id === _id)} onClick={(e) => handleSelectItem(_id, e.target.checked)} /></td>
            <td>{formatName(name)}</td>
            <td>{getSku(listSkus)}</td>
            <td>{moment(created_at).format("HH:mm DD/MM/YYYY")}</td>
            <td>{moment(updated_at).format("HH:mm DD/MM/YYYY")}</td>
            <td>
                <div>
                    <CategoryEdit
                        categoryItem={category}
                        skus={skus}
                        reload={reload}
                    />
                    <Popconfirm
                        title={`Chắc chắn muốn xóa danh mục ${name}?`}
                        onConfirm={() => onleDelete(category._id, name)}
                        okText="Xóa"
                        cancelText="Hủy"
                    >
                        <i className="fa fa-trash fa-lg text-danger" />
                    </Popconfirm>
                </div>
            </td>
        </tr>
    )
}

export default CategoryRow